'use client';

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils/tw-merge';

type Props = {
    id: string;
    hidden: boolean;
    className?: string;
    children: ReactNode;
};

/**
 * Body of the category disclosure. It stays mounted while collapsed (the
 * `hidden` attribute takes it out of the accessibility tree) so the service
 * switches keep their ids and the list does not re-mount on every toggle.
 */
export function ConsentServiceList({ id, hidden, className, children }: Props) {
    return (
        <ul id={id} hidden={hidden} className={cn('mt-3 divide-y border-s ps-4', className)}>
            {children}
        </ul>
    );
}
